module.exports = __webpack_public_path__ + "static/media/Shane Chase.716cc36a.png";